export default function PriorityNoteFlag({ width = 12, height = 12, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_3105_120517)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.87937 5.41131C9.924 5.42175 11.0099 5.43259 12 4.53409L9.41739 0C8.46277 0.898418 7.39633 0.887657 6.36241 0.877224C5.10777 0.864563 3.90099 0.852386 3 2.46591L5.50435 7C6.40527 5.3866 7.61193 5.39865 8.87937 5.41131ZM0.0751708 2.09802L5.52376 11.6357C5.75727 12.0025 6.2243 12.0759 6.61348 11.9292C7.00267 11.7091 7.0805 11.2689 6.92483 10.902L1.47624 1.36435C1.24273 0.997517 0.775704 0.924151 0.386519 1.07088C-0.00266625 1.29098 -0.0805033 1.73119 0.0751708 2.09802Z'
          fill='#D10D44'
        />
      </g>
      <defs>
        <clipPath id='clip0_3105_120517'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
